var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictureInPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51574 5.64051H10.1562C10.3332 5.64051 10.487 5.57551 10.6175 5.44551C10.7475 5.31501 10.8125 5.16126 10.8125 4.98426V2.59401C10.8125 2.41701 10.7475 2.26326 10.6175 2.13276C10.487 2.00276 10.3332 1.93776 10.1562 1.93776H6.51574C6.33874 1.93776 6.18499 2.00276 6.05449 2.13276C5.92449 2.26326 5.85949 2.41701 5.85949 2.59401V4.98426C5.85949 5.16126 5.92449 5.31501 6.05449 5.44551C6.18499 5.57551 6.33874 5.64051 6.51574 5.64051ZM1.56274 10.0003C1.19824 10.0003 0.888244 9.87251 0.632744 9.61701C0.377744 9.36201 0.250244 9.05226 0.250244 8.68776V1.31226C0.250244 0.947756 0.377744 0.638006 0.632744 0.383006C0.888244 0.127506 1.19824 -0.000244141 1.56274 -0.000244141H11.4372C11.8017 -0.000244141 12.1117 0.127506 12.3672 0.383006C12.6222 0.638006 12.7497 0.947756 12.7497 1.31226V8.68776C12.7497 9.05226 12.6222 9.36201 12.3672 9.61701C12.1117 9.87251 11.8017 10.0003 11.4372 10.0003H1.56274ZM1.56274 8.68776H11.4372V1.31226H1.56274V8.68776ZM7.17199 4.32801V3.25026H9.49999V4.32801H7.17199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureInPicture);
export default __webpack_public_path__ + "static/media/picture_in_picture.df947b0f80a0593abc456b8256e2ebed.svg";
export { ForwardRef as ReactComponent };